<user-personal-info-mobile *ngIf="isMobile"></user-personal-info-mobile>
<user-personal-info-desktop *ngIf="!isMobile"></user-personal-info-desktop>